import { BlockUI } from 'primereact/blockui';
import './dialog-header.styles.css';
import styles from './loading-blocker.module.css';

interface Props {
	title: string;
	blocked?: boolean;
}

const DialogHeader = ({ title, blocked }: Props) => {
	return blocked !== undefined ? (
		<BlockUI blocked={blocked} className={styles.formBlock}>
			<div className="dialog-header">{title}</div>
		</BlockUI>
	) : (
		<div className="dialog-header">{title}</div>
	);
};

export default DialogHeader;
